import * as React from "react";
import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16560_1912)">
      <path
        d="M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM8.14844 5.56582L6.95898 9.68652C6.89336 9.92168 6.86055 10.0775 6.86055 10.15C6.86055 10.1924 6.87832 10.232 6.9125 10.2689C6.94668 10.3059 6.98359 10.3236 7.02324 10.3236C7.08887 10.3236 7.15449 10.2949 7.22012 10.2361C7.39375 10.0926 7.60293 9.83418 7.84629 9.45957L8.04316 9.57578C7.45937 10.593 6.84004 11.1016 6.18242 11.1016C5.93086 11.1016 5.73125 11.0305 5.58223 10.8896C5.4332 10.7488 5.35938 10.5697 5.35938 10.3537C5.35938 10.2102 5.39219 10.0297 5.45781 9.8082L6.26309 7.03691C6.34102 6.77031 6.3793 6.56934 6.3793 6.43398C6.3793 6.34922 6.34238 6.27402 6.26855 6.2084C6.19473 6.14277 6.09492 6.10996 5.96777 6.10996C5.91035 6.10996 5.84063 6.11133 5.75859 6.11543L5.83379 5.88301L7.79844 5.56445H8.14844V5.56582ZM8.3918 4.35312C8.225 4.51992 8.02402 4.60195 7.78887 4.60195C7.55645 4.60195 7.3582 4.51855 7.19141 4.35312C7.02461 4.18633 6.94258 3.98535 6.94258 3.7502C6.94258 3.51504 7.02461 3.31406 7.18867 3.14727C7.35273 2.98184 7.55234 2.89844 7.78887 2.89844C8.02813 2.89844 8.23047 2.98184 8.39453 3.14727C8.55859 3.31406 8.64062 3.51504 8.64062 3.7502C8.64062 3.98535 8.55723 4.18633 8.3918 4.35312Z"
        fill="#4D555F"
      />
    </g>
    <defs>
      <clipPath id="clip0_16560_1912">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
